import * as React from 'react';
import Common from '../../utilities/common';
import { Entity, PermissionLevel } from '../../utilities/Permisos';
import $ from "jquery";
import { Alert, Button, FormControl, Paper, Stack, TextField, Typography } from '@mui/material';
import bg from '../../images/access_denied.jpg';
import bg2 from '../../images/access_denied2.jpg';
import SecurityOutlinedIcon from '@mui/icons-material/SecurityOutlined';

export interface ISecurityTrimmerProps {
    children: string | JSX.Element | JSX.Element[];
    entity: Entity;
    permission: PermissionLevel;
    noAccessMessage?: string;
}

export interface ISecurityTrimmerState {
    hasPermission: boolean;
    checking: boolean;
}

export default class SecurityTrimmer extends React.Component<ISecurityTrimmerProps, ISecurityTrimmerState> {
    public constructor(props: ISecurityTrimmerProps) {
        super(props);

        this.state = {
            hasPermission: false,
            checking: true
        }
    }

    componentDidMount(): void {
        this.CheckPermissions();
    }

    public render(): React.ReactElement<{}> {
        return (
            <React.Fragment>
                {
                    this.state.hasPermission && (
                        this.props.children
                    )
                }
                {
                    !this.state.hasPermission && !this.state.checking && !Common.IsNullOrEmpty(this.props.noAccessMessage!) && (
                        <div className='loginContainer' style={{backgroundImage: `url(${bg2})`, height: window.screen.availHeight}}>
                            <div className='card dark' style={{width: '600px', padding: '100px'}}>
                                <Stack direction='row' >
                                    <SecurityOutlinedIcon style={{fontSize: '102px'}}/>
                                    <div>
                                        <Typography variant="h3">
                                        Acceso denegado
                                        </Typography>
                                        <Typography variant="h6">
                                        {
                                            this.props.noAccessMessage
                                        }
                                        </Typography>
                                    </div>
                                </Stack>                                
                            </div>
                        </div>
                    )
                }
            </React.Fragment>
        )
    }

    private CheckPermissions(): void {
        const userId = Common.GetUserProp('id');

        let url = `${Common.END_POINT}/permissions/${userId}/${this.props.entity}/${this.props.permission}`;
        
        $.ajax((
            {
                url: url,
                type: "GET",
                headers: {
                    "Accept": "application/json",
                    "Content-Type": "application/json"
                },
                beforeSend: function (xhr) {
                    xhr.setRequestHeader('Authorization', `Bearer ${Common.GetToken()}`);
                }
            }
        )).done((response: boolean) => {
            if(!response && !Common.IsNullOrEmpty(this.props.noAccessMessage!)) {
                $('body').css('overflow', 'hidden');
            }
            this.setState(
                {
                    hasPermission: response,
                    checking: false
                }
            );
        }).fail((jqXHR: any, textStatus: any, errorThrown: any) => {
            if(jqXHR.status == 401) {
                const source = window.location.href;
                window.location.href = `/login?source=${source}`;
            }
        });
    }
}